export const LIMIT_LOW  = 98.0
export const LIMIT_HIGH = 101.4
export const IDEAL_LOW  = 99.0
export const IDEAL_HIGH = 100.5

/* Usadas até 29/09/2025
export const LIMIT_LOW  = 98.0
export const LIMIT_HIGH = 102.0
export const IDEAL_LOW  = 99.0
export const IDEAL_HIGH = 100.0
*/

/* Usadas até 22/09/2025
export const LIMIT_LOW  = 97.0
export const LIMIT_HIGH = 103.0
export const IDEAL_LOW  = 100.0
export const IDEAL_HIGH = 101.2
*/

export function getSeverity(value) {
  if (value < LIMIT_LOW || value > LIMIT_HIGH) return 'CRITICO'
  if (value < IDEAL_LOW || value > IDEAL_HIGH) return 'ATENCAO'
  return 'OK'
}

export function severityRank(s) {
  return s === 'CRITICO' ? 2 : s === 'ATENCAO' ? 1 : 0
}

export function score(value) {
  // distância do centro da faixa ideal, maior = pior
  const center = (IDEAL_LOW + IDEAL_HIGH) / 2
  return Math.abs(value - center)
}
